import type { MeasureSimulationCandidateDTO } from '@/src/api/types/procurement'
import { BaseText } from '@/src/components/BaseText'
import { EditMenu } from '@/src/components/EditMenu'
import { LocationBadge } from '@/src/components/LocationBadge'
import { formatMeasurement } from '@/src/utils/formatMeasurement'
import { Flex, Td, Tr, useDisclosure } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { LuEye } from 'react-icons/lu'
import LoadPlanningMeasureModal from '../LoadPlanningMeasureModal/LoadPlanningMeasureModal'
import { mapMeasureCandidateToLoadPlanningMeasureModalItem } from '../LoadPlanningMeasureModal/LoadPlanningMeasureModal.types'

export type MeasureCandidateTableRowData = MeasureSimulationCandidateDTO & { type: string }

export const MeasureCandidateTableRow = ({ row }: { row: MeasureCandidateTableRowData }) => {
  const { t } = useTranslation()
  const measureModal = useDisclosure()

  return (
    <Tr _hover={{ bg: 'gray.50' }}>
      <Td>
        <BaseText>{row.name}</BaseText>
      </Td>

      <Td>
        <BaseText>{row.type}</BaseText>
      </Td>

      <Td>
        <BaseText>
          <LocationBadge locationId={row.locationId} />
        </BaseText>
      </Td>

      <Td textAlign='right'>
        <Flex justifyContent={'end'} alignItems={'center'} gap={3}>
          <BaseText>
            {(row.consumptionDelta ?? 0) > 0 ? '+' : ''}
            {formatMeasurement(row.consumptionDelta, 'kWh')}
          </BaseText>
        </Flex>
      </Td>

      <Td>
        <EditMenu
          disableEdit={true}
          disableDelete={true}
          customOptions={[
            {
              name: t('common.view'),
              icon: <LuEye size='16px' />,
              onClick: measureModal.onOpen,
            },
          ]}
        />
      </Td>
      {measureModal.isOpen && (
        <LoadPlanningMeasureModal
          isOpen={measureModal.isOpen}
          onClose={measureModal.onClose}
          isCandidate={true}
          measureItem={mapMeasureCandidateToLoadPlanningMeasureModalItem(row)}
        />
      )}
    </Tr>
  )
}
